/**
 * Central brand definition.
 *
 * Flock: today, one bird - your own Codex, always aloft.
 * Tomorrow, a whole formation of agents behind a lead bird (the orchestrator).
 * Change the name here and it propagates through the client UI.
 */
export const BRAND = {
  name: "Flock",
  tagline: "Your own Codex. Always on.",
  description:
    "Sign in to Flock, connect ChatGPT, and pair your phone. In about two minutes, Codex has its own always-on computer, ready wherever you are.",
} as const;
